<template>
  <v-container fluid
               class="pa-0">
    <v-row class="full-height"
           no-gutters>
      <v-col cols="12"
             class="full-height">
        <v-row class="full-height"
               style="background-color: orange; min-height: 80px"
               no-gutters
        >
          <v-col cols="2" style="background-color: #4D5965;" class="pa-4 d-flex justify-center align-center">ID Vaca</v-col>
          <v-col cols="4" style="background-color: #4D5965;" class="pa-4 d-flex justify-center align-center">DIm</v-col>
          <v-col cols="6" style="background-color: #4D5965;" class="pa-4 d-flex justify-center align-center">Grupo</v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--v-row v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
      <v-col md="2" class="smartbell-smartbellLeftSideDesktop" v-if="userData.onboarding === true">
      </v-col>
      <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
        <v-dialog
                v-model="deleteCow"
                max-width="40%">
          <v-card class="DashCow-deleteCowCard">
            <v-card-title class="DashCow-deleteCowTitle DashCow-blueText"><h3>Cuidado</h3></v-card-title>
            <v-card-text class="DashCow-deleteCowDescription">
              <p class="DashCow-blueText">¿Esta seguro que desea borrar esta vaca del sistema?</p>
            </v-card-text>
            <v-card-actions class="DashCow-alignCenter">
              <v-btn class="smartbell-redButton" @click="closeDeletedCow()">
                Cancelar
              </v-btn>
              <v-btn class="smartbell-greenButton DashCow-leftButton" text>
                Entendido
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row align="center" justify="center" v-if="userData.onboarding === false">
          <v-col cols="10" class="DashCow-title">
            <h2>Esta es tu lista de vacas. Continua agregando tus vacas al sistema</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" class="DashCow-firstRowInfo">
            <v-row class="DashCow-noPadding">
              <v-col md="5" class="DashCow-noPadding DashCow-cowTypeDiv">
                <div class="DashCow-cowTypeDivFirst">
                  <img src="../assets/icons/calf.svg" alt="">
                </div>
                <div class="DashCow-cowTypeDivSecond">
                  <span>{{formattedHeifersNumber}}</span>
                </div>
              </v-col>
              <v-col md="5" offset-md="1" class="DashCow-noPadding DashCow-cowTypeDiv">
                <div class="DashCow-cowTypeDivFirst">
                  <img src="../assets/icons/bull.svg" alt="">
                </div>
                <div class="DashCow-cowTypeDivSecond">
                  <span>{{ formattedCowsNumber }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="4">
            <ChangeRanch></ChangeRanch>
          </v-col>
          <v-col md="4" style="text-align:end;" class="DashCow-cowNumber DashCow-cowNumberPadding">
            <span class="DashCow-cowNumberLeft">Vacas en sistema</span><span class="DashCow-cowNumberRight">{{ cowsNumber }}</span>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" class="DashCow-mainRow">
          <v-col cols="12">
            <v-card class="DashCow-allCowsCard">
              <v-toolbar dark color="#1460AA">
                <v-toolbar-title class="DashCow-tooltipTitle"> Listado
                  <v-select
                          :items="animalTypesList"
                          item-text="text"
                          solo
                          item-value="value"
                          v-model="animalType"
                  >
                  </v-select>
                </v-toolbar-title>
              </v-toolbar>
              <v-row style="padding: 18px; padding-top:0;" v-if="userData.onboarding === false">
                <v-col md="4" class="DashCow-cowButton">
                  <v-btn class="smartbell-greenButton smartbell-buttonCorrection"
                         x-small
                         @click="openSectionOnboarding('AddCows')">Agregar Vaca<img src="../assets/adultCow.png" alt="" style="margin-left:5%;"></v-btn>
                </v-col>
                <v-col md="4" offset-md="4" style="text-align:end;" class="DashCow-cowNumber">
                  <span class="DashCow-cowNumberLeft">Vacas en sistema</span><span class="DashCow-cowNumberRight">{{animalsNumber}}</span>
                </v-col>
              </v-row>
              <v-row style="padding: 18px; padding-top:0;" v-if="userData.onboarding === false">
                <v-col md="3">
                  <v-text-field
                          outlined
                          label="Buscar vaca por ID"
                          placeholder="ID Vaca"
                          append-icon="search"
                          v-model="searchText"
                  />
                </v-col>
                <v-col md="3" offset-md="3">
                  <v-select
                          :items="firstFilterOptions"
                          label="Filtros disponibles"
                          v-model="firstFilterSelected"
                          placeholder="Categoría"
                          outlined
                  />
                </v-col>
                <v-col md="3">
                  <v-select
                          :items="secondFilterOptions"
                          :placeholder="secondPlaceHolder"
                          :disabled="secondFilterDisabled"
                          outlined
                  />
                </v-col>
              </v-row>
              <v-row style="padding: 18px; padding-top:0;" v-if="userData.onboarding === true">
                <v-col md="3" class="DashCow-marginTop">
                  <v-btn class="smartbell-greenButton smartbell-buttonCorrection" @click="openPage('CowForm')">Agregar Vaca<img src="../assets/adultCow.png" alt="" style="margin-left:5%;"></v-btn>
                </v-col>
                <v-col md="3" class="DashCow-marginTop">
                  <v-text-field
                          outlined
                          label="Buscar vaca por ID"
                          placeholder="ID Vaca"
                          append-icon="search"
                          v-model="searchText"
                  />
                </v-col>
                <v-col md="3" class="DashCow-marginTop">
                  <v-select
                          :items="firstFilterOptions"
                          label="Filtros Disponibles"
                          v-model="firstFilterSelected"
                          placeholder="Categoría"
                          outlined
                  />
                </v-col>
                <v-col md="3" class="DashCow-marginTop">
                  <v-select
                          :items="secondFilterOptions"
                          :placeholder="secondPlaceHolder"
                          :disabled="secondFilterDisabled"
                          v-model="secondFilterSelected"
                          outlined
                  />
                </v-col>
              </v-row>
              <v-row style="padding: 28px; padding-top:0; padding-bottom:0;" class="DashCow-titleListContainer">
                <v-col md="2" cols="3" class="DashCow-titleList DashCow-titleListFirst">
                  <span>ID vaca  </span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                </v-col>
                <v-col md="2" cols="3" class="DashCow-titleList">
                  <span>Raza</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                </v-col>
                <v-col md="2" cols="3" class="DashCow-titleList">
                  <span>Estado</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                </v-col>
                <v-col md="2" cols="3" class="DashCow-titleList">
                  <span>DIM</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                </v-col>
                <v-col md="2" cols="3" class="DashCow-titleList">
                  <span>Grupo</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                </v-col>
                <v-col md="2" cols="3" class="DashCow-titleList DashCow-titleListLast">
                  <span>Acciones</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                </v-col>
              </v-row>
              <div class="DashCow-allCowList">
                <v-row style="padding: 28px; padding-top:0; padding-bottom:0;" class="DashCow-cowListContainer" v-for="animal in animalsToRender" :key="animal.id">
                  <v-col md="2" cols="3" class="DashCow-cowList DashCow-cowListFirst" @click="openCowProfile(animal)">
                    <img src="../assets/Vacaadulta.svg" alt=""> <span>{{animal.id}}</span>
                  </v-col>
                  <v-col md="2" cols="3" class="DashCow-cowList"  @click="openCowProfile(animal)">
                    <span>{{animal.breed}}</span>
                  </v-col>
                  <v-col md="2" cols="3" class="DashCow-cowList"  @click="openCowProfile(animal)">
                    <span>{{animal.milkState}}</span>
                  </v-col>
                  <v-col md="2" cols="3" class="DashCow-cowList"  @click="openCowProfile(animal)">
                    <span>{{animal.dim}}</span>
                  </v-col>
                  <v-col md="2" cols="3" class="DashCow-cowList"  @click="openCowProfile(animal)">
                    <span>{{animal.group}}</span>
                  </v-col>
                  <v-col md="2" cols="3" class="DashCow-cowList DashCow-cowListLast">
                    <v-icon class="DashCow-cowListAction">edit</v-icon><v-icon class="DashCow-cowListAction" @click="openDeleteAnimal(animal.key)">delete</v-icon>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-row v-if="userData.onboarding === false">
              <v-col cols="6" md="4" offset-md="4" style="text-align:center; align-items:center; display:flex; justify-content:center;">
                <img src="../assets/OmitirPaso.png" alt="" @click="openSectionOnboarding('DashHome')" class="GroupForm-groupFormButtons">
              </v-col>
              <v-col cols="6" md="4"  style="text-align:right;">
                <img src="../assets/BotonContinuar.png" alt="" @click="openSectionOnboarding('AddGroup')" class="GroupForm-groupFormButtons">
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>-->
  </v-container>
</template>

<script>
    export default {
        name: "NewDashCow"
    }
</script>

<style scoped>

</style>